export default {
	datatable: {
		expand: 'Erweitern',
		filterData: 'Datensätze filtern',
		sendCredentials: {
			title: 'Zugangsdaten versenden',
			confirm:
				'Bitte bestätigen Sie, dass folgende {count} Benutzer eine Begrüßungsemail erhalten sollen. Hierbei wird das bestehende Passwort überschrieben.',
			selectRecipients: 'Empfänger auswählen',
			warningExternal:
				'Bitte beachten Sie, dass diese Benachrichtigung auch an Personen per E-Mail geschickt wird, die als externe Zeugen angegeben wurden, obwohl diese nicht die Nutzungsbestimmungen und Datenschutzerklärung für HausPerfekt MOBILE zugestimmt haben.',
			additionalInfo: 'Zusätzliche Informationen',
			send: 'Versenden',
			choiceInfo:
				'Bitte treffen Sie die Wahl, ob alle Benutzer oder nur Benutzer mit aktiver Personenfunktion eine Begrüßungsmail erhalten sollen.',
			choiceExtra:
				'Wählen Sie zusätzlich, ob nur Benutzer, die sich bisher nicht angemeldet haben, eine Begrüßungsmail erhalten sollen.',
			allUsers: 'Alle Benutzer',
			activeUsers: 'Benutzer mit aktiver Personenfunktion',
			neverLoggedIn: 'Ohne vorherige Anmeldung',
		},
	},
}
